<template>
  <v-container fill-height fluid>
    <v-layout align-center justify-center>
      <v-card flat>
        <v-card class="elevation-12" min-width="500">
          <v-card-title class="justify-center">
            <v-img
              lazy-src="/logo-sectools-light.png"
              max-height="150"
              max-width="250"
              contain
              src="/logo-sectools-light.png"
            ></v-img>
          </v-card-title>
          <v-card-text class="text-center"
            >Maintenance en cours ...</v-card-text
          >
          <v-toolbar dark color="primary">
            <v-spacer></v-spacer>
            <v-img
              lazy-src="monadnDark.png"
              max-height="100"
              max-width="250"
              contain
              src="monadnDark.png"
            ></v-img>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "NotFound",
};
</script>
<style scoped>
p {
  font-weight: bold;
  font-size: 25px;
  text-align: center;
  color: #f10b0b;
}
</style>
